<template>
  <div v-if="visible" class="fixed inset-0 w-full h-full z-[2100] flex items-center justify-center bg-white bg-opacity-100">
    <div class="w-full h-full relative">
      <img class="absolute inset-0 w-full h-full object-cover" src="/img/dc_img/load_screen.webp" alt="">
    </div>
    <LoaderSvg strokeColor="#BD2025" sizeClass="absolute w-24 h-24 md:w-32 md:h-32"/>
  </div>
</template>

<script setup>
import LoaderSvg from "@/components/Ui/LoaderSvg.vue"
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'

const store = useStore() 
const load_carrusel = computed(() => store.state.comunes?.load_carrusel)
const visible = ref(true);
const timeoutId = ref(null);
const { trace } = useTraceLog('components->Ui->DcLoadScreen.vue')

onMounted(() => { 
  trace("DcLoadScreen onMounted() -> load_carrusel.value:", load_carrusel.value);
  
  if (load_carrusel.value) {
    visible.value = false;
  } else {
    timeoutId.value = setTimeout(() => {
      visible.value = false;
      timeoutId.value = null;
      trace("DcLoadScreen onMounted() -> timeout de seguridad 2.5s activado");
    }, 2500);
  }
});

watch(load_carrusel, (newValue) => {
  trace("DcLoadScreen watch -> load_carrusel cambió a:", newValue);
  
  if (newValue === true) {
    visible.value = false;
    
    if (timeoutId.value) {
      clearTimeout(timeoutId.value);
      timeoutId.value = null;
      trace("DcLoadScreen watch -> timeout cancelado por carga completada");
    }
  }
});
</script>

<style scoped>
.animate-pulse {
  animation: pulse 4s cubic-bezier(0.3, 0, 0.7, 1) infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
</style>